import axios from 'axios'
import store from '../store';
// import NProgress from 'nprogress'
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_SETTINGS_API_URL,
    withCredentials: true, // This is the default
})
apiClient.interceptors.request.use(config => { // Called on request
    // NProgress.start()
    store.state.layout.isLoading = true;
    return config
})
apiClient.interceptors.response.use(response => { // Called on response
    // NProgress.done()
    setTimeout(() => {
        store.state.layout.isLoading = false;
    }, 200)
    return response
})
apiClient.defaults.headers.common['x-requested-with'] = 'xmlhttprequest';

export default apiClient